import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useAuth } from '../hooks/useAuth';

import { Link } from '@tanstack/react-location';
import LogoutModal from './dialogs/LogoutDialogs';
import DevPanel from './DevPanel/DevPanel';
import { Container } from 'react-bootstrap';
import { getActiveProps } from '../helpers/utils';

const routes = [
  'Home',
  'Clients',
  'Invoicing',
  'Payment',
  'Reports',
  'Queues',
  'Jobs',
  'Tickets',
  'Analytics',
  'Towing',
  'Communications',
  'Registrations'
];

function NavBar() {
  const { isAuthenticated, hasScope } = useAuth();
  return (
    <Navbar hidden={!isAuthenticated} collapseOnSelect expand="lg" bg="primary" variant="dark">
      <Container>
        <Navbar.Brand href="/home">WeFightTickets</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            {routes.map((route, index) => (
              <Nav.Link
                key={index}
                as={Link}
                to={'/' + route.toLowerCase().replace(' ', '-')}
                className="text-nav"
                getActiveProps={getActiveProps}>
                {route}
              </Nav.Link>
            ))}
            {hasScope('admin') && (
              <Nav.Link as={Link} to="/users" className="text-nav" getActiveProps={getActiveProps}>
                Users
              </Nav.Link>
            )}
          </Nav>
          <Nav>
            <DevPanel />
            <LogoutModal />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
